import React, { useState } from 'react';

import Animate from 'components/organisms/Animate';
import Container from 'components/organisms/Container';
import Modal from 'components/organisms/Modal';
import TitleSection from 'components/organisms/TitleSection';
import VideoCard from 'components/organisms/VideoCard';

export type VideoType = 'video' | 'youtube'
export interface VideoHomeItemProps {
  isLive: boolean;
  thumbnail: string;
  videoUrl: string;
  description: string;
  type: VideoType;
}

interface VideoHomeProps {
  title: string;
  viewMoreText: string;
  href: string;
  videoList: VideoHomeItemProps[];
  target?: string;
}

const VideoHome: React.FC<VideoHomeProps> = ({
  videoList,
  title,
  viewMoreText,
  href,
  target,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [videoSelected, setVideoSelected] = useState(videoList[0]);
  return (
    <div className="t-videoHome">
      <Container>
        <TitleSection
          title={title}
          viewMoreText={viewMoreText}
          href={href}
          target={target}
        />
        {videoList.length ? (
          <div className="t-videoHome_flex">
            <div className="t-videoHome_main">
              <Animate type="slideInLeft">
                <VideoCard
                  description={videoList[0].description}
                  handleClick={() => {
                    setVideoSelected(videoList[0]);
                    setIsOpen(true);
                  }}
                  imageBackground={videoList[0].thumbnail}
                  isLive={videoList[0].isLive}
                  isSmaller={false}
                />
              </Animate>
            </div>
            <div className="t-videoHome_extra">
              <Animate type="slideInRight">
                <div className="t-videoHome_extra_wrapper">
                  {videoList.map(
                    (video, index) => index !== 0
                      && index < 4 && (
                        <div
                          className="t-videoHome_extra_item"
                          key={`videoHome-${index.toString()}`}
                        >
                          <VideoCard
                            description={video.description}
                            handleClick={() => {
                              setIsOpen(true);
                              setVideoSelected(video);
                            }}
                            imageBackground={video.thumbnail}
                            isLive={video.isLive}
                            isSmaller
                          />
                        </div>
                    ),
                  )}
                </div>
              </Animate>
            </div>
          </div>
        ) : null}
        <Modal
          isOpen={isOpen}
          className="player"
          handleClose={() => setIsOpen(false)}
        >
          {videoSelected?.type === 'youtube' ? (
            <iframe
              width="100%"
              src={videoSelected.videoUrl}
              title={videoSelected.description}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            // eslint-disable-next-line jsx-a11y/media-has-caption
            <video src={videoSelected?.videoUrl} controls />
          )}
        </Modal>
      </Container>
    </div>
  );
};

VideoHome.defaultProps = {
  target: '_self',
};

export default VideoHome;
